/** @file Props and types shared among Fieldset, RadioButtons, Checkboxes components. */
import p from 'vue-strict-prop';
/** Common props shared among choice components and its sub-components. */
export const commonProps = {
    /** Value given via name prop will be assigned to the name attributes of the input elements within. */
    name: p(String).optional,
    /** The title of this set of inputs (fieldset element). */
    legend: p(String).required,
    /** The description of this set of inputs. */
    description: p.ofType().optional,
    /**
     * If the set of inputs (fieldset element) is disabled.
     *
     * Value is assigned to <fieldset> as well as the individual inputs.
     */
    disabled: p(Boolean).default(false),
    /** If the set of inputs is readonly. */
    readonly: p(Boolean).default(false),
    /**
     * The appearance of this set of choices.
     *
     * Default renders conventional checkbox or radio buttons.
     * Card-like renders them in a rounded box.
     */
    variant: p.ofStringLiterals('default', 'card-like', 'quiz').default('default'),
    /* Appearance Customization */
    legendClasses: p.ofType().optional,
    optionClasses: p.ofType().optional,
    optionsWrapperClasses: p.ofType().optional,
    optionLabelClass: p.ofType().default('label-large'),
};
